import styled from 'styled-components'


export const Title = styled.div`
    top: -15vh;
    position: absolute;
    width: 100%;
    height: 8vh;
    display: flex;
    align-items: center;
    padding: 30px;
    font-family: Michroma;
    letter-spacing: 1vw;
    font-weight: bold;
    justify-content: center;
    color: #fff;
    
    background-color: ${({bg_color}) => bg_color};
    font-family: 'Roboto';
    font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};

    @media screen and (max-width: 1000px) {
        font-size: 3vw;
    }
    @media screen and (max-width: 786px) {
        font-size: 24px;
    }
`

export const TitleWrapper = styled.div`
    margin-top: 40vh;
    margin-bottom: 5vh;
    width: 100%;
    position: relative;
`

export const DescWrapper = styled.div`
    display: inline-block;
    width: 40vw;
    margin-top: 5vh;
    padding-top: 8vh;
    padding-bottom: 40px;
    padding-left: 40px;

    @media screen and (max-width: 786px) {
        width: 80vw;
        padding-top: 40px;
        padding-left: 20px;
    }
`


export const DescriptionText = styled.p`
    font-size: ${({size}) => (size==='') ? 'inherit' : size};
    line-height: 1.2;

    @media screen and (max-width: 786px) {
        font-size: 12px;
    }
`

export const ColumnWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 15px;
`

export const ColumnTitle = styled.h1`
    top: -3.6vh;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 70px;
    line-height: 4vh;
    background-color: ${({bg_color}) => bg_color ? bg_color : 'inherit'};
    font-size: 2.2vw;
    padding: 1.3vh 30px 2.4vh;
    border-radius: 30px;
    @media screen and (max-width: 480px) {
        top: -3.6vh;
        font-size: 15px;
        line-height: 2;
        padding: 6px 10px;
        width: 70vw;
    }
    @media screen and (max-width: 300px) {
        line-height: 1.4;
    }
`

export const RowWrapper = styled.div`
    background-color: #363636;
    width: 100%;
    margin-top: 8vh;
`
